module.exports = __webpack_public_path__ + "img/mobile-56.207222d7.png";